let routes = [{
		path: '/',
		name: 'layout',
		redirect: {
			name: 'index'
		},
		component: 'layout',
		children: [
			{
				meta:{title:'home'},
				component: 'index/index'
			},
			
			// 数据统计
			{
				meta:{title:'total'},
				component: 'data/day'
			},
			
			// 预警列表
			{
				meta:{title:'warn'},
				component: 'data/warn'
			},

			// 腾讯云账号管理
			{
				meta:{title:'account'},//用户列表
				component: 'cloudac/account'
			},
			{
				meta:{title:'apply'},//申请记录
				component: 'cloudac/apply'
			},

			
			// cdn管理
			{
				meta:{title:'cert'},//证书管理
				component: 'cdn/cert'
			},
			{
				meta:{title:'domain'},//域名管理
				component: 'cdn/domain'
			},
			{
				meta:{title:'cdnProduct'},//套餐管理
				component: 'cdn/product'
			},
			{
				meta:{title:'detail'},//套餐管理
				component: 'cdn/detail'
			},
			{
				meta:{title:'source'},//源站管理
				component: 'cdn/source'
			},
			{
				meta:{title:'server'},//服务器管理
				component: 'cdn/server'
			},
				
			

			// 系统设置
			{
				meta:{title:'setBase'},
				component: 'set/base/index'
			},
			{
				meta:{title:'adminList'},
				component: 'set/admin/index'
			},
			{
				meta:{title:'role'},
				component: 'set/manager/index'
			},
			{
				meta:{title:'managerRule'},
				component: 'set/manager/rule'
			},
			{
				meta:{title:'message'},
				component:'data/message'
			},
			{
				meta:{title:'quest'},
				component:'data/quest'
			},
			
			//域名管理
			{
				meta:{
					title:'mydomain',
					requireAuth: false
				},
				component: 'domain/list'
			},
			{
				path: 'domain/dns/:id',
				meta:{
					title:'dnsManage',
					requireAuth: false
				},
				component: 'domain/dns'
			},
			{
				meta:{
					title:'domainTemplate',
					requireAuth: false
				},
				component: 'domain/template'
			},
			{
				meta:{
					title:'domainPrice',
					requireAuth: false
				},
				component: 'domain/price'
			},


			// 云服务管理
			{
				meta:{title:'cloudService'},//云服务商列表
				component: 'cloud/cloudService'
			},
			{
				meta:{title:'product'},//云产品列表
				component: 'cloud/product'
			},
			{
				meta:{title:'cloudArea'},//地区列表
				component: 'cloud/area'
			},

			//供应商管理
			{
				meta:{title:'supplierList'},//供应商列表
				component: 'supplier/index'
			},

			//用户管理
			{
				meta:{title:'user'},
				component: 'user/user'
			},
			{
				meta:{title:'userReg'},
				component: 'user/reg'
			},

			//财务管理
			{
				meta:{title:'bill'},//财务流水
				component: 'finance/order'
			},
			{
				meta:{title:'charge'},//收款地址
				component: 'finance/charge'
			},
			{
				meta:{title:'apply'},//申请记录
				component: 'finance/apply'
			},
			{
				meta:{title:'userPay'},//用户流水
				component: 'finance/pay'
			},
			{
				meta:{title:'monList'},//用户流水
				component: 'finance/mon'
			},
			
			//腾讯云
			{
				meta:{title:'apply'},
				component: 'tx/apply'
			},
			{
				meta:{title:'bill'},
				component: 'tx/bill'
			},
			{
				meta:{title:'userList'},
				component: 'tx/user'
			},
			{
				meta:{title:'userList'},
				component: 'tx/total'
			},

			//阿里云
			{
				meta:{title:'bill'},
				component: 'al/bill'
			},
			{
				meta:{title:'apply'},
				component: 'al/apply'
			},
			{
				meta:{title:'user'},
				component: 'al/user'
			},
			


			{
				meta:{title:'agentList'},
				component: 'user/agent'
			},
			
			{
				meta:{title:'userList'},
				component: 'aws/user'
			},
			
			
			{
				meta:{title:'bill'},
				component: 'aws/bill'
			},
			
		

			{
				meta:{title:'apply'},
				component: 'aws/apply'
			},
			
			
			{
				meta:{title:'404'},
				component: 'error/404'
			}
		]
	},
	{
		// path:'/login',
		// name:'login',
		//component:()=>import('../../views/login/index.vue')
		meta:{title:'登錄页'},
		component: 'login/index'
	},
	{
		path: '*',
		redirect: {
			name: 'index'
		}
	}
]
// 获取路由信息方法
let getRoutes = function() {
	// 生成路由详细信息
	createRoute(routes)
	return routes
}
// 自动生成路由
function createRoute(arr) {
	for (let i = 0; i < arr.length; i++) {
		if (!arr[i].component) return
		// 去除index
		let val = getValue(arr[i].component)
		// 生成name
		arr[i].name = arr[i].name || val.replace(/\//g, '_')
		// 生成apth
		arr[i].path = arr[i].path || `/${val}`
		// 自动生成component
		let componentFun = import(`../../views/${arr[i].component}.vue`)
		arr[i].component = () => componentFun
		if (arr[i].children && arr[i].children.length > 0) {
			createRoute(arr[i].children)
		}
	}
}
// 去除index
function getValue(str) {
	// str = login/index
	// 获取最後一个/索引
	let index = str.lastIndexOf('/')
	// 获取最後一个/後面的值
	let val = str.substring(index + 1, str.length)
	// 判断是不是index结尾
	if (val === 'index') {
		return str.substring(index, -1)
	}
	return str
}
export default getRoutes()
